// js/main.js (VERSÃO FINAL COM TEMPLATES PRÉ-CARREGADOS VIA VITE)

import { Router } from './router.js';
import HeaderManager from './header-manager.js';
import supabase from './supabase-config.js';

// --- Imports de Templates HTML via Vite (?raw) ---
import homeTemplate from '../public/templates/home.html?raw';
import gameInfoTemplate from '../public/templates/game-info.html?raw';
import cardsTemplate from '../public/templates/cards.html?raw';
import storeTemplate from '../public/templates/store.html?raw';
import newsTemplate from '../public/templates/news.html?raw';
import newsArticleTemplate from '../public/templates/news-article.html?raw';
import loreTemplate from '../public/templates/lore.html?raw';
import contactTemplate from '../public/templates/contact.html?raw';
import loginTemplate from '../public/templates/login.html?raw';
import signupTemplate from '../public/templates/signup.html?raw';
import resetPasswordTemplate from '../public/templates/reset-password.html?raw';
import authCallbackTemplate from '../public/templates/auth-callback.html?raw';
import profileTemplate from '../public/templates/profile.html?raw';
import settingsTemplate from '../public/templates/settings.html?raw';
import cartTemplate from '../public/templates/cart.html?raw';
import communityTemplate from '../public/templates/community.html?raw';
import newTopicTemplate from '../public/templates/new-topic.html?raw';
import publicProfileTemplate from '../public/templates/public-profile.html?raw';

// --- Admin Templates ---
import adminDashboardTemplate from '../public/templates/admin/dashboard.html?raw';
import adminNewsManagementTemplate from '../public/templates/admin/news-management.html?raw';
import adminNewsEditorTemplate from '../public/templates/admin/news-editor.html?raw';
import adminStoreManagementTemplate from '../public/templates/admin/store-management.html?raw';
import adminStoreEditorTemplate from '../public/templates/admin/store-editor.html?raw';
import adminBannerManagementTemplate from '../public/templates/admin/banner-management.html?raw';
import adminBannerEditorTemplate from '../public/templates/admin/banner-editor.html?raw';
import adminUserManagementTemplate from '../public/templates/admin/user-management.html?raw';
import fallbackTemplate from '../public/templates/404.html?raw';

const routes = [
    // --- Rotas Principais ---
    { path: '/', template: homeTemplate, js: './pages/home.js', title: 'Início' },
    { path: '/o-jogo', template: gameInfoTemplate, js: './pages/gameInfo.js', title: 'Como Jogar' },
    { path: '/cartas', template: cardsTemplate, js: './pages/cardsExplorer.js', title: 'Explorador de Cartas' },
    // { path: '/loja', template: storeTemplate, js: './pages/store.js', title: 'Loja' },
    { path: '/noticias', template: newsTemplate, js: './pages/news.js', title: 'Notícias' },
    { path: '/noticias/:slug', template: newsArticleTemplate, js: './pages/news-article.js', title: 'Notícia' },
    { path: '/mundo', template: loreTemplate, js: './pages/lore.js', title: 'O Mundo de Eldraem' }, 
    { path: '/mundo/:section', template: loreTemplate, js: './pages/lore.js', title: 'O Mundo de Eldraem' }, 
    { path: '/contato', template: contactTemplate, js: './pages/contact.js', title: 'Contato' },
    
    // --- Rotas de Usuário (Autenticação e Perfil Pessoal) ---
    { path: '/login', template: loginTemplate, js: './pages/login.js', title: 'Entrar' },
    { path: '/criar-conta', template: signupTemplate, js: './pages/signup.js', title: 'Criar Conta' },
    { path: '/esqueci-senha', template: resetPasswordTemplate, js: './pages/resetPassword.js', title: 'Recuperar Senha' },
    { path: '/auth/callback', template: authCallbackTemplate, js: './pages/authCallback.js', title: 'Carregando sessão...' },
    { path: '/perfil', template: profileTemplate, js: './pages/profile.js', title: 'Meu Perfil' },
    { path: '/configuracoes', template: settingsTemplate, js: './pages/settings.js', title: 'Configurações' },
    // { path: '/carrinho', template: cartTemplate, js: './pages/cart.js', title: 'Carrinho' },

    // --- Rotas Sociais / Comunidade ---
    { path: '/comunidade', template: communityTemplate, js: './pages/community.js', title: 'Comunidade' },
    { path: '/comunidade/forum', template: communityTemplate, js: './pages/community.js', title: 'Fórum da Comunidade' },
    { path: '/comunidade/forum/categoria/:slug', template: communityTemplate, js: './pages/community.js', title: 'Categoria - Fórum' },
    { path: '/comunidade/forum/topico/:topicId', template: communityTemplate, js: './pages/community.js', title: 'Tópico - Fórum' },
    { path: '/comunidade/forum/novo-topico', template: newTopicTemplate, js: './pages/newTopic.js', title: 'Novo Tópico - Fórum' },
    { path: '/comunidade/mensagens', template: communityTemplate, js: './pages/community.js', title: 'Mensagens' },
    { path: '/comunidade/perfil/:username', template: publicProfileTemplate, js: './pages/publicProfile.js', title: 'Perfil' },
    { path: '/comunidade/amigos', template: communityTemplate, js: './pages/community.js', title: 'Amigos' },
    { path: '/comunidade/buscar-amigos', template: communityTemplate, js: './pages/community.js', title: 'Buscar Jogadores' },
    
    // --- Rotas de Admin ---
    { path: '/admin', template: adminDashboardTemplate, js: './pages/admin/dashboard.js', title: 'Painel do Administrador' },
    { path: '/admin/news', template: adminNewsManagementTemplate, js: './pages/admin/news-management.js', title: 'Gerenciar Notícias' },
    { path: '/admin/news/create', template: adminNewsEditorTemplate, js: './pages/admin/news-editor.js', title: 'Criar Notícia' },
    { path: '/admin/news/edit/:postId', template: adminNewsEditorTemplate, js: './pages/admin/news-editor.js', title: 'Editar Notícia' },
    // { path: '/admin/store', template: adminStoreManagementTemplate, js: './pages/admin/store-management.js', title: 'Gerenciar Loja' },
    // { path: '/admin/store/create', template: adminStoreEditorTemplate, js: './pages/admin/store-editor.js', title: 'Adicionar Item' },
    // { path: '/admin/store/edit/:itemId', template: adminStoreEditorTemplate, js: './pages/admin/store-editor.js', title: 'Editar Item' },
    { path: '/admin/banner', template: adminBannerManagementTemplate, js: './pages/admin/banner-management.js', title: 'Gerenciar Banners' },
    { path: '/admin/banner/create', template: adminBannerEditorTemplate, js: './pages/admin/banner-editor.js', title: 'Criar Banner' },
    { path: '/admin/banner/edit/:slideId', template: adminBannerEditorTemplate, js: './pages/admin/banner-editor.js', title: 'Editar Banner' },
    { path: '/admin/users', template: adminUserManagementTemplate, js: './pages/admin/user-management.js', title: 'Gerenciar Usuários' },
    
    // --- Rota de Fallback ---
    { path: '/404', template: fallbackTemplate, js: null, title: 'Página Não Encontrada' },
];

/**
 * Configura a interatividade do menu hamburger e o fechamento ao clicar fora.
 */
function setupMobileMenu() {
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const navContainer = document.getElementById('mobile-nav-container');

    if (!hamburgerBtn || !navContainer) return;

    hamburgerBtn.addEventListener('click', () => {
        document.body.classList.toggle('nav-open');
    });

    navContainer.addEventListener('click', (e) => {
        if (e.target.tagName === 'A') {
            document.body.classList.remove('nav-open');
        }
    });

    document.addEventListener('click', (e) => {
        if (
            document.body.classList.contains('nav-open') &&
            !e.target.closest('#hamburger-btn') &&
            !e.target.closest('#mobile-nav-container')
        ) {
            document.body.classList.remove('nav-open');
        }
    });
}

// Função principal de inicialização do site
function initializeSite() {
    console.log('[Main] Script principal carregado. Inicializando o site...');
    
    HeaderManager.init();
    
    window.router = new Router(routes);
    window.router.init();

    supabase.auth.onAuthStateChange((event, session) => {
        if (event === "PASSWORD_RECOVERY") {
            console.log("[Main] Evento de recuperação de senha detectado. Redirecionando...");
            window.router.navigate('/esqueci-senha?recovery=true');
        }
    });

    document.body.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (!link) return;

        let href = link.getAttribute('href');
        const target = link.getAttribute('target');

        if (href) {
            // Normaliza links com "#/" para "/" para compatibilidade com a nova History API
            if (href.startsWith('#/')) {
                href = href.substring(1);
            }

            // Intercepta cliques em links internos que iniciam com / e não têm target="_blank"
            if (href.startsWith('/') && !href.startsWith('//') && target !== '_blank') {
                e.preventDefault();
                window.router.navigate(href);
            }
        }
    });

    setupMobileMenu();

    console.log('[Main] Site Runeweave pronto para navegação.');
}

document.addEventListener('DOMContentLoaded', initializeSite);